module.exports = __webpack_public_path__ + "img/t2-c7.1c11f5e0.png";